import axios from "axios";
import { createAsyncThunk } from "@reduxjs/toolkit";
export const getAdminDetail = createAsyncThunk(
  "login/getAdminDetail",
  async (data, thunkAPI) => {
    try {
      const resp = await axios.get(
        `${process.env.REACT_APP_BASE_URL}api/users/auth`,
        data,
        {
          headers: {
            Authorization: "Bearer " + localStorage.token,
            "Content-Type": "application/json",
          },
        }
      );
      localStorage.setItem("userId", resp.data?.data?.id);
      return resp.data?.data;
    } catch (error) {
      if (error.response) {
        return thunkAPI.rejectWithValue(error.response.data.message);
      } else {
        return thunkAPI.rejectWithValue(error.message);
      }
    }
  }
);
